// extracted by mini-css-extract-plugin
export default {"readOnly":"CustomInput_readOnly__hbk3M","fullWidth":"CustomInput_fullWidth__NlcXA"};